import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suzuki-app-link',
  templateUrl: './suzuki-app-link.component.html',
  styleUrls: ['./suzuki-app-link.component.css'],
  standalone: false
})
export class SuzukiAppLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const userAgent = navigator.userAgent || navigator.vendor;

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isMobile = /mobile|tablet|iphone|ipad|android/i.test(userAgent);

    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.suzuki.salesmanager&hl=en";

    const appStoreUrl =
      "https://apps.apple.com/us/app/mint360lms/id6738463708";

    if (isMobile) {
      if (isAndroid) {
        // Android → Play Store
        window.location.href = playStoreUrl;

        // fallback timeout
        setTimeout(() => {
          window.location.href = playStoreUrl;
        }, 1000);

      } else if (isIOS) {
        // iOS → App Store
        setTimeout(() => {
          window.location.href = appStoreUrl;
        }, 1000);

      } else {
        // Other mobile → Play Store
        window.location.href = playStoreUrl;
      }
    } else {
      // Desktop → Play Store
      window.location.href = playStoreUrl;
    }
  }

}
